module.exports = __webpack_public_path__ + "images/144_1024.jpg";